import React, { useEffect, useState } from "react";
import Select, { ActionMeta, MultiValue } from "react-select";
import TaskCreationLKValues from "../../../../interfaces/lkValues/TaskCreationLKValues";
import { useAuth } from "../../../../firebase/AuthProvider";
import { getTaskLKValues } from "../../../../services/taskServices/TaskLKService";
import {
    publishInterimTemplate,
} from "../../../../services/taskServices/TaskService";
import { useNavigate } from "react-router-dom";
import NewInterimTemplate from "../../../../interfaces/task/NewInterimTemplate";
import TextEditor from "../../textEditor/TextEditor";
import TemplateFile from "../../../../interfaces/task/TaskFiles/TemplateFile";
import { getTemplateFiles } from "../../../../services/fileServices/FileService";
import { Button, Form } from "react-bootstrap";
import Tag from "../../../../interfaces/tag/Tag";
import { getAllTags } from "../../../../services/tagServices/TagService";

interface OptionType {
    value: string;
    label: string;
}

const AddTemplateInterimTask: React.FC = () => {
    const { currentUser, currentOrganization } = useAuth();
    const navigate = useNavigate();

    const [fileTemplates, setFileTemplates] = useState<TemplateFile[] | null>();
    const [formattedFileTemplates, setFormattedFileTemplates] = useState<
        OptionType[]
    >([]);

    // State for tags
    const [allTags, setAllTags] = useState<Tag[]>([]);
    const [formattedTags, setFormattedTags] = useState<OptionType[]>([]);

    const [newTemplate, setNewTemplate] = useState<NewInterimTemplate>({
        title: "",
        description: "",
        information: "",
        requiredFiles: [],
        assignee: undefined,
        coAssignee: undefined,
        participant: undefined,
        daysFromCreationDueDate: "0",
        taskOrganization: "1",
        taskType: "1",
        taskSubType: "4",
        dueDate: "",
        workflowGroup: "Standard",
        tags: []
    });

    const [lkOptions, setLkOptions] = useState<
        TaskCreationLKValues | null | undefined
    >();

    useEffect(() => {
        // Fetch the task with taskId and update the state
        const fetchLkValues = async () => {
            if (currentUser !== null) {
                const authToken: string = await currentUser.getIdToken();
                const fetchedValues: TaskCreationLKValues | null =
                    await getTaskLKValues(authToken);
                setLkOptions(fetchedValues);
            }

            if (currentUser !== null) {
                const fetchTemplateFiles = async () => {
                    const authToken: string = await currentUser.getIdToken();
                    const fetchedTemplateFiles = await getTemplateFiles(authToken);
                    setFileTemplates(fetchedTemplateFiles);
                };

                fetchTemplateFiles();
            }
        };

        if (lkOptions && fileTemplates) {
            const formattedFileTemplates = fileTemplates.map((file) => ({
                value: file.id.toString(),
                label: file.fileName,
            }));
            if (formattedFileTemplates) {
                setFormattedFileTemplates(formattedFileTemplates);
            }
        }
        if (!lkOptions) {
            fetchLkValues();
        }
    }, [lkOptions, fileTemplates]);


    useEffect(() => {
        fetchAllTags();
    }, []);

    // 4) Format the tags for react-select
    useEffect(() => {
        if (allTags.length > 0) {
            const newTagOptions = allTags.map((tag) => ({
                value: tag.id.toString(),
                label: tag.name,
            }));
            setFormattedTags(newTagOptions);
        }
    }, [allTags]);

    const fetchAllTags = async () => {
        try {
            if (!currentUser) return;
            const authToken = await currentUser.getIdToken();
            const tags = await getAllTags(authToken);
            if (tags) {
                setAllTags(tags);
            }
        } catch (error) {
            console.error("Error fetching tags:", error);
        }
    };

    const handleChange = (
        e: React.ChangeEvent<
            HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
        >
    ) => {
        const { name, value } = e.target;
        setNewTemplate({ ...newTemplate, [name]: value });
    };

    const handleDayInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNewTemplate({
            ...newTemplate,
            daysFromCreationDueDate: event.target.value,
        });
    };

    const handleRequiredFileChanges = (
        selectedOptions: MultiValue<OptionType>,
        actionMeta: ActionMeta<OptionType>
    ) => {
        const requiredFiles = selectedOptions
            ? selectedOptions.map((option) => option.value)
            : [];
        setNewTemplate({ ...newTemplate, requiredFiles });
    };

    const handleInfoChange = (infoText: string) => {
        setNewTemplate({ ...newTemplate, information: infoText });
    };

    //   const handleCustomChange = (
    //     fieldName: keyof newTemplate,
    //     fieldValue: string | undefined
    //   ) => {
    //     setNewTemplate({ ...newTemplate, [fieldName]: fieldValue });
    //   };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        // return;
        // Handle submitting the new task
        const createTask = async () => {
            if (currentUser !== null) {
                const authToken: string = await currentUser.getIdToken();
                const newTaskId: number | null = await publishInterimTemplate(
                    authToken,
                    newTemplate
                );
                return newTaskId;
            }
            return null;
        };
        const idPromise = createTask();

        idPromise.then((id) => {
            if (id !== null && id !== undefined) {
                // Redirect to new task here.
                navigate(`/edit/interims`);
            } else {
                console.error("Failed to create task");
            }
        });
    };

    const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setNewTemplate({ ...newTemplate, [name]: value });
    };

    // ===== NEW: handle Tag changes =====
    const handleTagChanges = (
        selectedOptions: MultiValue<OptionType>,
        actionMeta: ActionMeta<OptionType>
    ) => {
        // We store the array of numeric IDs (or strings if you prefer).
        const selectedTagIds = selectedOptions.map((opt) => Number(opt.value));
        setNewTemplate({ ...newTemplate, tags: selectedTagIds });
    };

    return (
        <>
            <div className="new_activity_container">
                <div className="common_card">
                    <div className="top border_tittle">
                        <div className="top_bar_tittle">
                            <h2>New Interim Template</h2>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="custom_input_flled">
                            <label htmlFor="title">Title</label>
                            <input
                                type="text"
                                id="title"
                                name="title"
                                placeholder="Give your task a title..."
                                value={newTemplate.title}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="custom_input_flled">
                            <label htmlFor="description">Description</label>
                            <textarea
                                id="description"
                                name="description"
                                placeholder="A brief description of what the task entails..."
                                value={newTemplate.description}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="custom_input_flled">
                            <label htmlFor="info">Information</label>
                            <TextEditor
                                text={newTemplate.information}
                                setText={handleInfoChange}
                            />
                        </div>
                        <div className="custom_input_flled">
                            <label htmlFor="requiredFiles">Required Files{" "}
                                <span>(Optional)</span>:
                            </label>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                options={formattedFileTemplates}
                                isMulti
                                onChange={handleRequiredFileChanges}
                                value={formattedFileTemplates.filter((option) =>
                                    newTemplate.requiredFiles.includes(option.value)
                                )}
                            />
                        </div>
                        <div className="custom_input_flled mb-0">
                            <label>Due date from creation</label>
                            <input
                                type="number"
                                min={"1"}
                                max={"365"}
                                value={newTemplate.daysFromCreationDueDate}
                                onChange={handleDayInputChange}
                                placeholder={"Days until completion..."}
                            />
                        </div>

                        <div className="custom_input_flled mt-3 mb-3">
                            <label>Select Sub-Type</label>
                            <Form.Select
                                size="lg"
                                value={newTemplate.taskSubType}
                                onChange={(e) =>
                                    setNewTemplate({ ...newTemplate, taskSubType: e.target.value })
                                }
                            >
                                <option value="4">INTERIM</option>
                                <option value="5">CIR</option>
                            </Form.Select>
                        </div>

                        {/* ===== NEW: Tags ===== */}
                        <div className="custom_input_flled mb-0">
                            <label htmlFor="tags">Tags <span>(Optional)</span>:
                            </label>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                options={formattedTags}
                                isMulti
                                onChange={handleTagChanges}
                                // Pre-select tags if newTemplate.tags is not empty
                                value={formattedTags.filter((tagOption) =>
                                    newTemplate.tags?.includes(Number(tagOption.value))
                                )}
                            />
                        </div>
                        <div className="form_btn_flx mby_t_24">
                            <Button onClick={(e) => handleSubmit} type="submit">Create Template</Button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default AddTemplateInterimTask;
